import script from "./base-info.vue?vue&type=script&lang=ts&setup=true"
export * from "./base-info.vue?vue&type=script&lang=ts&setup=true"

import "./base-info.vue?vue&type=style&index=0&id=f77bdb96&lang=scss&scoped=true"

import exportComponent from "D:\\Projects\\WebStorm\\operation-platform\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f77bdb96"]])

export default __exports__